import { useState } from "react";
import type { Faq } from "@/types/content";

interface FaqAccordionProps {
  items: Faq[];
}

export default function FaqAccordion({ items }: FaqAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <div className="divide-y divide-background-200 overflow-hidden rounded-lg border border-background-200 bg-background-50">
      {items.map((item, index) => {
        const open = openIndex === index;
        return (
          <div key={item.q}>
            <button
              type="button"
              aria-expanded={open}
              onClick={() => setOpenIndex(open ? null : index)}
              className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left transition-colors hover:bg-background-100 cursor-pointer"
            >
              <span className="font-heading text-sm font-semibold text-foreground-950 md:text-base">{item.q}</span>
              <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-600">
                <i className={open ? "ri-subtract-line" : "ri-add-line"} />
              </span>
            </button>
            {open && (
              <div className="px-5 pb-5">
                <p className="font-body text-sm leading-relaxed text-foreground-600">{item.a}</p>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}